import React, { useState, useEffect } from 'react';
import {
    TextField, InputAdornment, Paper, Checkbox, Box, Button
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search';
import { makeStyles } from '@mui/styles';
import CustomDialog from '../../../sharedcomponents/dialog/dialog';
import UserList from './userList';
import ButtonContainer from '../../../sharedcomponents/buttoncontainer/buttonContainer';
import Helper from '../../../utility/helper';
//import { useState, Downgraded } from '@hookstate/core';
import ApiHelper from '../../../utility/ApiHelper';
import APIURLConstants from '../../../config/config';
import UserCheckList from '../../../sharedcomponents/userList/userCheckList';

const useStyles = makeStyles({
    dialogContentRoot: {
        // maxHeight: 400,
        // overflowY: 'hidden',
        '&::-webkit-scrollbar': {
            width: '5px',
            height: '5px',
            backgroundColor: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
        },
    },
});

const UserListDialog = (props) => {
    //console.log('props', props);
    const classes = useStyles();
    // const selectedUsers = useState([]);
    const [users, setUsers] = useState([])
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [allCheck, setAllCheck] = useState(false);

    useEffect(() => {
        if (props.users.length > 0 && users.length == 0) {
            setUsers(props.users);
        }
    }, [props.users])

    const checkSelectedUsers = (selectedUsers) => {
        setSelectedUsers(selectedUsers);
    }
    const handleOnSearchChange = (val) => {

        let value = val.replace(/^\s+/g, '');
        setSearch(value);
        let newUsers = [...props.users];
        if (value.length > 0) {
            newUsers = props.users.filter(x => x.name.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
                (x.roleName !== null && x.roleName.toLowerCase().indexOf(value.toLowerCase()) > -1) ||
                (x.userTags !== null && x.userTags.toLowerCase().indexOf(value.toLowerCase()) > -1)
            )
            setUsers(newUsers)
        } else {
            setUsers([...props.users])
        }


    }
    const handleAllCheck = () => {
        let data = [];
        users.map((item) => {
            data.push(item.userID);
        });
        if (allCheck === false) {
            setAllCheck(true)
            setSelectedUsers(data)
        } else {
            setAllCheck(false)
            setSelectedUsers([])
        }
    }
    const renderDialogContent = () => (
        <>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'left',
                alignItems: 'left',
            }}>
                {!props.isView && (props.selectAllCheckBox && <Checkbox
                    edge="start"
                    checked={allCheck}
                    onChange={handleAllCheck}
                    disableRipple
                    sx={{ ml: "4px" }}
                />)}
                <TextField
                    size="small"
                    fullWidth={true}
                    placeholder="Search Individuals"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon />
                            </InputAdornment>
                        ),
                    }}
                    value={search}
                    onChange={(event) => handleOnSearchChange(event.target.value)}
                />
            </Box>
            <Paper>
                <UserCheckList
                    data={users}
                    checkUsers={checkSelectedUsers}
                    selectedUsers={selectedUsers}
                    showRole={true}
                    sentInvitationList={props.sentInvitationList}
                />
            </Paper>
        </>
    );

    const renderDialogActions = () => (

        <ButtonContainer
            handleClick={handleClick}
            handleCancel={props.handleClose}
            buttonText={'Add'}
            loading={loading}
            showLoading={true}
        />
    );
    const uniqArray = (arrays) => {
        const uniqueIds = [];
        const unique = arrays.filter((element) => {
            const isDuplicate = uniqueIds.includes(element.userID);
            if (!isDuplicate) {
                uniqueIds.push(element.userID);
                return true;
            }
            return false;
        });
        return unique;
    };

    const handleClick = () => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (selectedUsers)
            if (selectedUsers.length == 0) {
                props.setSnackBarProps({
                    ...props.snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please select participants',
                });
                setLoading(false);
            } else {
                setLoading(true);
                let userIDs = [];
                let users = [...selectedUsers];
                // console.log("users", users);

                // console.log('users', users, props.mediaCircuitActivity);
                let requestObj = [];
                props.mediaCircuitActivity.length > 0 &&
                    props.mediaCircuitActivity.map(() => {
                        users.forEach((item) => {
                            userIDs.push(item);
                            requestObj.push({
                                eventID: eventInfo.eventID,
                                activityTrackerID: 0,
                                userID: item,
                                status: 0,
                                createdBy: userInfo.userID,
                            });
                        });
                    });

                let uniqueArrays = uniqArray(requestObj);
                ApiHelper.post(
                    APIURLConstants.POST_USER_ACTIVITY_TRACKER_ACCESS,
                    uniqueArrays
                )
                    .then((res) => {
                        if (res.data) {
                            // console.log("res.data", res.data);
                            props.setSnackBarProps({
                                ...props.snackBarProps,
                                openSnack: true,
                                variant: 'success',
                                message: 'participant added successfully',
                            });
                            props.handleClose();
                            props.getAllData();
                        }
                    })
                    .catch((error) => {
                        let message = '';
                        if (error.response && error.response.status === 401) {
                            message = 'Access denied';
                        } else {
                            message = 'Error while adding participant';
                        }
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: message,
                        });
                    });
            }
    };

    return (
        <CustomDialog
            title={props.title}
            handleClose={props.handleClose}
            open={props.open}
            fullWidth={true}
            maxWidth={'sm'}
            // title={'Export Itinerary'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
            dialogContentClasses={{ root: classes.dialogContentRoot }}
        />
    );
};
export default UserListDialog;
